import { Dispatch } from 'redux'
import { applyFiltersDrawer } from '../../../actions/bookingCalendar/filtering/applyFiltersDrawer'
import { IFilterRoomsValues } from './withReduxForm'

export default function(values: IFilterRoomsValues, dispatch: Dispatch) {
  dispatch(applyFiltersDrawer(values))
}
